/**
 * MODULE: _shared/frontend-shell/src/features/crm/constants/crmTableConfig.ts
 * PURPOSE: Shared CRM hub table feature flags (RecordTable selection chrome, bulk toolbar)
 * DEPENDENCIES: none
 * PUBLIC_API: CRM_TABLE_CONFIG
 * SIDE_EFFECTS: None
 * AGENT_SAFETY: SAFE
 * FILE_SIZE: 18/80
 * RECENT: 2026-05-11 Task 9 #90 — **`BULK_ACTIONS_ENABLED`** gates checkbox column and **`BulkActionBar`** until toolbar ships
 */

/**
 * When true, **`RecordTable`** **`selectable`** shows row checkboxes, header select-all, and **`BulkActionBar`**.
 * Future toolbar copy (when enabled): "{N} selected · [Delete] [Assign] [Export] [× Clear]" — implement with bar, not only checkboxes.
 */
export const CRM_TABLE_CONFIG = {
  BULK_ACTIONS_ENABLED: false,
} as const;
